<template>
    <div class="formula-generator">
        <div v-if="!aiResult" class="prompt-container">
            <p>Supsis Asistan'a ne tür bir formül oluşturmak istediğinizi anlatın.</p>
            <s2-textarea
                v-model="customerPrompt"
                :rows="4"
                placeholder="Örnek: Fiyat ve miktar alanlarını çarpıp KDV ekleyerek toplam tutarı hesapla..."
                ref="promptTextarea"
            />
            <div class="assistant-buttons">
                <a-button type="primary" :loading="aiLoading" @click="generateFormula" :disabled="!customerPrompt">
                    Formül Oluştur
                </a-button>
            </div>

            <div class="example-prompts">
                <h4>Örnek İstekler:</h4>
                <div class="prompt-cards">
                    <div
                        class="prompt-card"
                        v-for="(prompt, index) in examplePrompts"
                        :key="index"
                        @click="customerPrompt = prompt"
                    >
                        <a-icon type="bulb" />
                        <p>{{ prompt }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="result-container">
            <div class="result-header">
                <h3>Oluşturulan Formül</h3>
            </div>
            <div class="result-formula">
                <pre>{{ aiResult.formula }}</pre>
            </div>
            <div class="result-explanation">
                <p>{{ aiResult.explanation }}</p>
            </div>
            <div class="result-buttons">
                <a-button type="primary" @click="useGeneratedFormula">Bu Formülü Kullan</a-button>
                <a-button @click="resetAiAssistant">Yeni Formül Oluştur</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import CoPilot from "../../../../../../utils/CoPilot";
import S2Textarea from "../../../../../../components/S2Textarea.vue";

export default Vue.extend({
    name: "FormulaGenerator",
    components: {
        S2Textarea
    },
    props: {
        tableId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            customerPrompt: "",
            aiLoading: false,
            aiResult: null,
            examplePrompts: [
                "İki sayısal alanın toplamını hesapla ve sonucu 2 ondalık basamağa yuvarla",
                "Fiyat alanını miktarla çarpıp, %18 KDV ekleyerek toplam tutarı hesapla",
                "Ad ve soyad alanlarını birleştirip tam isim oluştur",
                "Eğer satış tutarı 1000'den büyükse 'Yüksek', değilse 'Düşük' olarak değerlendir",
                "Doğum tarihi alanından yaşı hesapla",
                "Stok miktarı 10'dan az ise 'Kritik Stok', 10-50 arası ise 'Normal Stok', 50'den fazla ise 'Yüksek Stok' olarak göster",
                "Başlangıç tarihi ve bitiş tarihi arasındaki gün sayısını hesapla",
            ]
        };
    },
    methods: {
        async generateFormula() {
            if (!this.customerPrompt) return;

            this.aiLoading = true;

            try {
                const copilot = CoPilot.getInstance();
                const result = await copilot.createFormula({
                    siteId: this.$store.state.site.site._id,
                    tableId: this.tableId,
                    customerPrompt: this.customerPrompt,
                });

                if (result.error) {
                    this.$message.error(result.error);
                    return;
                }

                this.aiResult = result;
            } catch (error) {
                console.error("Formül oluşturma hatası:", error);
                this.$message.error("Formül oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.");
            } finally {
                this.aiLoading = false;
            }
        },

        useGeneratedFormula() {
            if (!this.aiResult || !this.aiResult.formula) return;
            // Parent bileşene formülü gönder
            this.$emit("formula-generated", this.aiResult.formula);
        },

        resetAiAssistant() {
            this.aiResult = null;
            this.customerPrompt = "";
        }
    },
});
</script>

<style lang="scss" scoped>
.formula-generator {
    .prompt-container {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .assistant-buttons {
            display: flex;
            justify-content: center;
            margin-top: 16px;
        }

        .example-prompts {
            margin-top: 24px;

            h4 {
                margin-bottom: 12px;
                text-align: center;
            }

            .prompt-cards {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .prompt-card {
                    padding: 12px;
                    border: 1px solid #e8e8e8;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.3s;
                    display: flex;
                    align-items: flex-start;

                    &:hover {
                        background-color: #f5f5f5;
                        transform: translateY(-2px);
                    }

                    .anticon {
                        color: #1890ff;
                        margin-right: 8px;
                        margin-top: 3px;
                    }

                    p {
                        margin: 0;
                    }
                }
            }
        }
    }

    .result-container {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .result-header {
            text-align: center;
            margin-bottom: 8px;

            h3 {
                margin: 0;
                color: #1890ff;
            }
        }

        .result-formula {
            background: #f5f5f5;
            padding: 16px;
            border-radius: 4px;
            border-left: 4px solid #1890ff;

            pre {
                margin: 0;
                white-space: pre-wrap;
                word-break: break-word;
                font-family: "Courier New", monospace;
            }
        }

        .result-explanation {
            padding: 0 8px;

            p {
                margin: 0;
                color: #666;
            }
        }

        .result-buttons {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-top: 16px;
        }
    }
}
</style>
